import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ExtensionStatus } from 'src/app/core/models/extension';

export interface StatusOption {
    value: ExtensionStatus;
    label: string;
}

interface StatusCellParams extends ICellRendererParams {
    statusOptions: StatusOption[];
    onStatusChange: (data: any, newStatus: ExtensionStatus, revert: () => void) => void;
    isLocked: (data: any) => boolean;
}

@Component({
    selector: 'app-status-cell-renderer',
    standalone: true,
    imports: [FormsModule],
    template: `
        @if (isOriginalContract || locked) {
            <span class="status-label">{{ currentLabel }}</span>
        } @else {
            <select class="form-select form-select-sm status-select" [(ngModel)]="currentStatus" (change)="onChange()">
                @for (option of statusOptions; track option.value) {
                    <option [ngValue]="option.value">{{ option.label }}</option>
                }
            </select>
        }
    `,
    styles: [`
        :host { display: flex; align-items: center; height: 100%; width: 100%; }
        .status-select { height: 30px; }
        .status-label { font-weight: 600; }
    `]
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {
    public statusOptions: StatusOption[] = [];
    public currentStatus: ExtensionStatus;
    public currentLabel = '';
    public locked = false;
    public isOriginalContract = false;

    private params: StatusCellParams;

    agInit(params: StatusCellParams): void {
        this.refresh(params);
    }

    refresh(params: StatusCellParams): boolean {
        this.params = params;
        this.statusOptions = params.statusOptions ?? [];
        this.isOriginalContract = !!params.data?.isOriginalContract;
        this.locked = !this.isOriginalContract && !!params.isLocked?.(params.data);
        this.currentStatus = params.value;
        this.currentLabel = this.statusOptions.find(o => o.value === this.currentStatus)?.label ?? '';
        return true;
    }

    onChange(): void {
        const previous = this.params.value;
        if (this.currentStatus === previous) {
            return;
        }
        const newStatus = this.currentStatus;
        this.params.onStatusChange(this.params.data, newStatus, () => {
            this.currentStatus = previous;
        });
    }
}
